import { ReportChartBlockDef } from './types';

const registry = new Map<string, ReportChartBlockDef[]>();

export function registerReportBlocks(module: string, blocks: ReportChartBlockDef[]): void {
  registry.set(module, blocks.slice());
}

export function getReportBlocksForModule(module: string): ReportChartBlockDef[] {
  return registry.get(module) ?? [];
}

export function getRegisteredModules(): string[] {
  return Array.from(registry.keys());
}

export function getReportBlockDefinition(module: string, key: string): ReportChartBlockDef | undefined {
  return getReportBlocksForModule(module).find((block) => block.key === key);
}
